import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'incidenRegelSetStatusStatus'
})
export class IncidenRegelSetStatusStatusPipe implements PipeTransform {
  transform(status: number): string {
    //StatusEnum { NietVerwerkt = 0, VerwerktSuccesvol = 1, BezigMetVerwerking = 2, VerwerktNietSuccesvol = 3 };
    var uitvoer = '';
    if (status) {
      switch (status) {
        case 0:
          uitvoer = 'NietVerwerkt';
          break;
        case 1:
          uitvoer = 'VerwerktEnVoldoet';
          break;
        case 2:
          uitvoer = 'BezigMetVerwerking';
          break;
        case 3:
          uitvoer = 'VerwerktEnVoldoetNiet';
          break;
        default:
          uitvoer = 'Status Onbekend';
          break;
      }
    }

    return uitvoer;
  }
}
